module.exports = __webpack_public_path__ + "ba12b2b828dca4e680e5a870e3014601.png";